// ── Impersonate Guard ──────────────────────────────────────
// Gunakan di semua halaman yang punya action edit/delete/save

export const isImpersonating = () => {
  return !!localStorage.getItem("impersonate_as_email");
};

// Wrap onClick handler — block jika sedang impersonate
export const guardAction = (fn, message = "Action disabled during impersonate session") => {
  return (...args) => {
    if (isImpersonating()) {
      alert("     Read-only mode: " + message + "\nExit impersonate session first.");
      return;
    }
    return fn(...args);
  };
};
